/**
 * WordPress dependencies
 */
import { registerBlockType } from '@wordpress/blocks';
import { textHorizontal as icon } from '@wordpress/icons';
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Internal dependencies
 */
import Edit from './edit';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
	/**
	 * @see ./edit.js
	 */
	icon,
	edit: Edit,
	save: () => <InnerBlocks.Content />,
} );
